import { supabase } from './supabase';

export const sendPasswordResetEmail = async (email, resetToken, resetLink) => {
  try {
    const { data, error } = await supabase.functions.invoke('send-password-reset-email', {
      body: {
        email,
        resetToken,
        resetLink
      }
    });

    if (error) {
      throw new Error(error.message || 'Failed to send password reset email');
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error sending password reset email:', error);
    throw error;
  }
};

export const sendAccountCreationEmail = async (email, tempPassword) => {
  try {
    const { data, error } = await supabase.functions.invoke('send-account-creation-email', {
      body: {
        email,
        tempPassword
      }
    });

    if (error) {
      throw new Error(error.message || 'Failed to send account creation email');
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error sending account creation email:', error);
    throw error;
  }
};
